import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from 'react';

interface FaceEditionContextProviderProps {
  children: ReactNode;
}

type FaceEditionContextData = {
  selectedImage?: Blob | string;
  setSelectedImage: Dispatch<SetStateAction<Blob | string | undefined>>;
  isImageChange: boolean;
  setIsImageChange: Dispatch<SetStateAction<boolean>>;
  snapshotImage?: Blob | string;
  setSnapshotImage: Dispatch<SetStateAction<Blob | string | undefined>>;
};

export const FaceEditionContext = createContext({} as FaceEditionContextData);

const FaceEditionContextProvider = ({
  children,
}: FaceEditionContextProviderProps) => {
  const [selectedImage, setSelectedImage] = useState<Blob | string>();
  const [isImageChange, setIsImageChange] = useState<boolean>(false);
  const [snapshotImage, setSnapshotImage] = useState<Blob | string>();

  return (
    <FaceEditionContext.Provider
      value={{
        selectedImage,
        setSelectedImage,
        isImageChange,
        setIsImageChange,
        snapshotImage,
        setSnapshotImage,
      }}
    >
      {children}
    </FaceEditionContext.Provider>
  );
};

export default FaceEditionContextProvider;
